// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Olive title on the page is 6.28; olive badge text on white is 7.24.
   Doubled class so page-level \`section { padding }\` rules don't override it. */
.feature-header.feature-header {
  text-align: center;
  padding: 56px 0 32px;
}

.feature-header h1 {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: clamp(2.6rem, 8vw, 4.5rem) !important;
  line-height: 1.05;
  letter-spacing: -0.01em;
  color: var(--color-olive);
  margin: 0 0 18px;
}

.feature-header p {
  max-width: 780px;
  margin: 0 auto;
  font-size: 1.2rem;
  line-height: 1.6;
}

.feature-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--surface-raised);
  color: var(--color-olive);
  font-size: 0.95rem;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 999px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(89, 88, 96, 0.12);
}

.feature-badge svg {
  color: var(--text-accent);
}

@media (max-width: 780px) {
  .feature-header p {
    font-size: 1.05rem;
  }
}

@media (max-width: 600px) {
  .feature-header.feature-header {
    padding: 32px 0 20px;
  }

  .feature-badge {
    margin-bottom: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeatureHeader.css"],"names":[],"mappings":"AAAA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;EAChD,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Olive title on the page is 6.28; olive badge text on white is 7.24.\n   Doubled class so page-level `section { padding }` rules don't override it. */\n.feature-header.feature-header {\n  text-align: center;\n  padding: 56px 0 32px;\n}\n\n.feature-header h1 {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: clamp(2.6rem, 8vw, 4.5rem) !important;\n  line-height: 1.05;\n  letter-spacing: -0.01em;\n  color: var(--color-olive);\n  margin: 0 0 18px;\n}\n\n.feature-header p {\n  max-width: 780px;\n  margin: 0 auto;\n  font-size: 1.2rem;\n  line-height: 1.6;\n}\n\n.feature-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: var(--surface-raised);\n  color: var(--color-olive);\n  font-size: 0.95rem;\n  font-weight: 600;\n  padding: 8px 18px;\n  border-radius: 999px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(89, 88, 96, 0.12);\n}\n\n.feature-badge svg {\n  color: var(--text-accent);\n}\n\n@media (max-width: 780px) {\n  .feature-header p {\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .feature-header.feature-header {\n    padding: 32px 0 20px;\n  }\n\n  .feature-badge {\n    margin-bottom: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
